import { createAsyncThunk } from '@reduxjs/toolkit';
import doFetch from 'utils/api/doFetch';

import type { ReportIssueRequestBody } from 'redux-store/slices/profile/types';

const reportIssueThunk = createAsyncThunk(
  'api/reportIssueThunk',
  async ({ data }: { data: ReportIssueRequestBody }) => {
    const apiPointName = 'reportIssue';

    return await doFetch<typeof apiPointName>({
      apiPointName,
      body: data,
    });
  },
);

export default reportIssueThunk;
